<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <b-input-group
            :append="append"
            :prepend="prepend"
            v-if="hasAppend || hasPrepend"
        >
            <template v-slot:append>
                <slot name="append"></slot>
            </template>
            <template v-slot:prepend>
                <slot name="prepend"></slot>
            </template>
            <b-form-input
                :class="input_class"
                :readonly="_is_readonly"
                v-bind="$attrs"
                v-bind:value="value"
                v-on="inputListeners"
            >
                <slot />
            </b-form-input>
        </b-input-group>

        <b-form-input
            v-else
            :class="input_class"
            :readonly="_is_readonly"
            v-bind="$attrs"
            v-bind:value="value"
            v-on="inputListeners"
        >
            <slot />
        </b-form-input>

        <span v-if="formState.debug">
            SE:{{ serverErrors }} [{{ serverErrorsIndex }}].{{ name }}<br />
            AL_SE:{{ all_server_errors }}
        </span>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";

export default {
    name: "OTextField",
    components: { OFormGroup },
    mixins: [FormComponentMixin],
    props: {
        prepend: { type: String, default: null },
        append: { type: String, default: null },
    },
    computed: {
        hasPrepend() {
            return this.prepend || !!this.$slots["prepend"];
        },
        hasAppend() {
            return this.append || !!this.$slots["append"];
        },
    },
};
</script>

<style scoped></style>
